import { useAppSelector } from "./useAppSelector";

export const useAuth = () => {
    const auth = useAppSelector((s) => s.auth);
    return {
        user: auth.user,
        isAuthenticated: !!auth.access_token && !!auth.user,
        isLoading: auth.status === "is_loading",
        errorMessage: auth.error_message,
    };
};
